import LiveChatIcon from "@styles/all-images/icons/dashboard-icons/live-chat.svg";
import TodoIcon from "@styles/all-images/icons/dashboard-icons/to-do-list.svg";
import CalendarIcon from "@styles/all-images/icons/dashboard-icons/calender.svg";
import ContactsIcon from "@styles/all-images/icons/dashboard-icons/contacts.svg";
import DocumentIcon from "@styles/all-images/icons/dashboard-icons/document.svg";
import SignIcon from "@styles/all-images/icons/dashboard-icons/sign.svg";
import ClientOnboardingIcon from "@styles/all-images/icons/dashboard-icons/client.svg";
import SupplierOnboardingIcon from "@styles/all-images/icons/dashboard-icons/supplier.svg";
import CRMIcon from "@styles/all-images/icons/dashboard-icons/crm.svg";
import AppointmentsIcon from "@styles/all-images/icons/dashboard-icons/apppointment.svg";
import QuotesIcon from "@styles/all-images/icons/dashboard-icons/quotes.svg";
import ClientFacilityIcon from "@styles/all-images/icons/dashboard-icons/sign.svg";
import AccountingIcon from "@styles/all-images/icons/dashboard-icons/accounting.svg";
import ManagementIcon from "@styles/all-images/icons/dashboard-icons/management-accounts.svg";
import FuelOrdersIcon from "@styles/all-images/icons/dashboard-icons/sign.svg";
import StockPurchasesIcon from "@styles/all-images/icons/dashboard-icons/stock-purchase.svg";
import StockManagementIcon from "@styles/all-images/icons/dashboard-icons/stock-inventory.svg";
import ReportsIcon from "@styles/all-images/icons/dashboard-icons/reports.svg";
import FinanceCovenantIcon from "@styles/all-images/icons/dashboard-icons/finance-covenant.svg";
import StaffManagementIcon from "@styles/all-images/icons/dashboard-icons/staff-management.svg";
import UserManagementIcon from "@styles/all-images/icons/dashboard-icons/user-management.svg";
import GeneralMasterIcon from "@styles/all-images/icons/dashboard-icons/general-masters.svg";
import RolesPermissionsIcon from "@styles/all-images/icons/dashboard-icons/roles-permissions.svg";
import CMSPageIcon from "@styles/all-images/icons/dashboard-icons/CMS-page.svg";
import ProfileManagementIcon from "@styles/all-images/icons/dashboard-icons/profile-management.svg";
import TierConfigurationIcon from "@styles/all-images/icons/dashboard-icons/tier-configuration.svg";
import ComingSoonIcon from "@styles/all-images/icons/dashboard-icons/ComingSoon.svg";

import {
  ClientOnboardingPermissions,
  CmsPermissions,
  ContactsPermissions,
  DocumentsPermissions,
  GeneralMastersPermissions,
  LiveChatPermissions,
  ProfileManagementPermissions,
  ReportsPermissions,
  RolesPermissionsPermissions,
  SignPermissions,
  StaffManagementPermissions,
  TierConfigurationPermissions,
  TodoPermissions,
  UsersPermissions,
} from "./permission-modules/base-permissions";

export interface MenuItem {
  icon: string;
  title: string;
  link: string;
  disabled?: boolean;
  permissions?: string[];
}

const baseStartMenuItems: MenuItem[] = [
  {
    icon: LiveChatIcon,
    title: "Live Chat",
    link: "/live-chat",
    permissions: [LiveChatPermissions.VIEW_LIVE_CHAT],
  },
  {
    icon: TodoIcon,
    title: "To Do",
    link: "/to-do",
    permissions: [TodoPermissions.VIEW_TO_DO],
  },
  {
    icon: ComingSoonIcon,
    title: "Calendar",
    link: "/calendar",
    disabled: true,
  },
  {
    icon: ContactsIcon,
    title: "Contacts",
    link: "/contacts",
    permissions: [ContactsPermissions.VIEW_CONTACTS],
  },
  {
    icon: DocumentIcon,
    title: "Document",
    link: "/document",
    permissions: [
      DocumentsPermissions.VIEW_IM_DOCUMENTS,
      DocumentsPermissions.VIEW_TERMS_SHEET_DOCUMENTS,
      DocumentsPermissions.VIEW_DOCUMENTS_TO_BE_APPROVED,
      DocumentsPermissions.VIEW_MY_DRIVE_DOCUMENTS,
    ],
  },
  {
    icon: SignIcon,
    title: "Sign",
    link: "/signed-documents?tab=tobeSigned",
    permissions: [SignPermissions.VIEW_SIGN],
  },
];
const baseEndMenuItems: MenuItem[] = [
  {
    icon: ReportsIcon,
    title: "Stakeholder\nReports",
    link: "/reports",
    permissions: [ReportsPermissions.VIEW_REPORTS],
  },
  {
    icon: StaffManagementIcon,
    title: "Operations Team",
    link: "/staff-management",
    permissions: [StaffManagementPermissions.VIEW_STAFF_MANAGEMENT],
  },
  {
    icon: RolesPermissionsIcon,
    title: "Roles & Permissions",
    link: "/roles-and-permissions",
    permissions: [RolesPermissionsPermissions.VIEW_ROLES_AND_PERMISSIONS],
  },
  {
    icon: ProfileManagementIcon,
    title: "Profile Management",
    link: "/profile-management",
    permissions: [ProfileManagementPermissions.VIEW_PROFILE_MANAGEMENT],
  },
];

const tier1MenuItems: MenuItem[] = [
  {
    icon: ComingSoonIcon,
    title: "Fund\nOn-boarding",
    link: "/Fund-onboarding",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Portfolio\nManagement",
    link: "/portfolio-management",
    disabled: true,
  },
];

const tier2MenuItems: MenuItem[] = [
  {
    icon: ComingSoonIcon,
    title: "Guarantor\nOn-boarding",
    link: "/guarantor-onboarding",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Portfolio\nManagement",
    link: "/portfolio-management",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Underwriting\nPortfolio\nPerformance",
    link: "/underwriting-portfolio-performance",
    disabled: true,
  },
];

const tier3MenuItems: MenuItem[] = [
  {
    icon: ClientOnboardingIcon,
    title: "Super Bulk\nOnboarding",
    link: "/client-onboarding/invited",
    permissions: [ClientOnboardingPermissions.VIEW_CLIENT_ONBOARDING],
  },
  {
    icon: ComingSoonIcon,
    title: "Client Facility\nTrades",
    link: "/client-facility",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Credit\nApproval",
    link: "/credit-approval",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Fund Portfolio\nMonitoring",
    link: "/fund-portfolio-monitoring",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Client Portfolio\nMonitoring",
    link: "/client-portfolio-monitoring",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Sentinel Risk\nMonitoring",
    link: "/sentinel-risk-monitoring",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Financial\nCovenant",
    link: "/finance-covenant",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Compliance",
    link: "/compliance",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Accounting",
    link: "/accounting",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Sentinel Asset\nManager",
    link: "/sentinel-asset-manager",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Sentinel Stock\nMonitoring",
    link: "/sentinel-stock-monitoring",
    disabled: true,
  },
  {
    icon: GeneralMasterIcon,
    title: "System Configurations",
    link: "/general-masters/commodity",
    permissions: [GeneralMastersPermissions.VIEW_GENERAL_MASTERS],
  },
  {
    icon: ComingSoonIcon,
    title: "Stakeholder Configuration",
    link: "/tier-configuration",
    permissions: [TierConfigurationPermissions.VIEW_TIER_CONFIGURATION],
    disabled: true,
  },
  {
    icon: CMSPageIcon,
    title: "Shield CMS",
    link: "/cms-page",
    permissions: [CmsPermissions.VIEW_CMS],
  },
  {
    icon: UserManagementIcon,
    title: "Stakeholder\nManagement",
    link: "/user-management/onboardedUsers",
    permissions: [UsersPermissions.VIEW_USERS_MANAGEMENT],
  },
];

const tier4MenuItems: MenuItem[] = [
  {
    icon: ClientOnboardingIcon,
    title: "Super Bulk\nOnboarding",
    link: "/client-onboarding/invited",
    permissions: [ClientOnboardingPermissions.VIEW_CLIENT_ONBOARDING],
  },
  {
    icon: ComingSoonIcon,
    title: "Supplier\nOn-boarding",
    link: "/supplier-onboarding",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "CRM",
    link: "/crm",
    disabled: true,
  },

  {
    icon: ComingSoonIcon,
    title: "Appointments",
    link: "/appointments",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Quotes",
    link: "/quotes",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Client Facility\nTrades",
    link: "/client-facility",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Accounting",
    link: "/accounting",
    disabled: true,
  },

  {
    icon: ComingSoonIcon,
    title: "Management\nAccounts",
    link: "/management",
    disabled: true,
  },

  {
    icon: ComingSoonIcon,
    title: "CDD/PPC\nFuel Orders",
    link: "/fuel-orders",
    disabled: true,
  },

  {
    icon: ComingSoonIcon,
    title: "Stock\nPurchases",
    link: "/stock-purchases",
    disabled: true,
  },

  {
    icon: ComingSoonIcon,
    title: "Stock\nManagement",
    link: "/stock-management",
    disabled: true,
  },

  {
    icon: ComingSoonIcon,
    title: "Financial\nCovenant",
    link: "/finance-covenant",
    disabled: true,
  },
];

const tier5MenuItems: MenuItem[] = [
  {
    icon: ComingSoonIcon,
    title: "CRM",
    link: "/crm",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Appointments",
    link: "/appointments",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Quotes",
    link: "/quotes",
    disabled: true,
  },
  {
    icon: ComingSoonIcon,
    title: "Client Facility\nTrades",
    link: "/client-facility",
    disabled: true,
  },
];

const tier6MenuItems: MenuItem[] = [
  {
    icon: ComingSoonIcon,
    title: "Super Bulk\nOnboarding",
    link: "/client-onboarding/invited",
    disabled: true,
    permissions: [ClientOnboardingPermissions.VIEW_CLIENT_ONBOARDING],
  },
];

const tier7MenuItems: MenuItem[] = [
  {
    icon: ComingSoonIcon,
    title: "Super Bulk\nOnboarding",
    link: "/client-onboarding/invited",
    disabled: true,
    permissions: [ClientOnboardingPermissions.VIEW_CLIENT_ONBOARDING],
  },
];

export const getMenuItemsByUserType = (userTypeId?: number): MenuItem[] => {
  let menuItems: MenuItem[] = [];
  switch (userTypeId) {
    case 1:
      menuItems = [
        ...baseStartMenuItems,
        ...tier1MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    case 2:
      menuItems = [
        ...baseStartMenuItems,
        ...tier2MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    case 3:
      menuItems = [
        ...baseStartMenuItems,
        ...tier3MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    case 4:
      menuItems = [
        ...baseStartMenuItems,
        ...tier4MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    case 5:
      menuItems = [
        ...baseStartMenuItems,
        ...tier5MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    case 6:
      menuItems = [
        ...baseStartMenuItems,
        ...tier6MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    case 7:
      menuItems = [
        ...baseStartMenuItems,
        ...tier7MenuItems,
        ...baseEndMenuItems,
      ];
      break;
    default:
      menuItems = [...baseStartMenuItems, ...baseEndMenuItems];
      break;
  }

  return menuItems;
};
